import { MouseEvent } from 'react'
import ToggleBothSides from './ToggleBothSides'
import ToggleLabeled from './ToggleLabeled'

export type ToggleProps = {
  labelA?: string
  labelB?: string
  toggled: boolean
  classes?: string
  labelDir?: 'left' | 'right'
  variant?: 'bothSides' | 'labeled'
  onToggle: (e: MouseEvent<HTMLButtonElement>) => void
}

const Toggle = ({ variant = 'labeled', ...rest }: ToggleProps) => {
  if (variant === 'labeled') {
    return <ToggleLabeled {...rest} />
  }
  return <ToggleBothSides {...rest} />
}

export default Toggle
